import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';

import { AppRoutingModule } from './app-routing.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AppComponent } from './app.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';


//+==================================== GLOBAL ====================================+\\
import { DashboardComponent } from './Components/Global/dashboard/dashboard.component';
import { LoginCDMSComponent } from './Components/Global/login-cdms/login-cdms.component';
import { SearchDocsApiComponent } from './Components/Global/search-docs-api/search-docs-api.component';
import { DocumentViewerComponent } from './Components/Global/document-viewer/document-viewer.component';


//+==================================== CONTENT ====================================+\\
//-======================== ADMINISTRATOR CDMS ========================-\\
import { AdministratorCDMSComponent } from './Components/Content/Admin/administrator-cdms/administrator-cdms.component';
import { AdminGroupsOfCDMSComponent } from './Components/Content/Admin/admin-groups-of-cdms/admin-groups-of-cdms.component';
import { RelationGroupCDMSComponent } from './Components/Content/Admin/relation-group-cdms/relation-group-cdms.component';
import { AdminnUsersofCDMSComponent } from './Components/Content/Admin/adminn-usersof-cdms/adminn-usersof-cdms.component';
import { AdminHeaderofCDMSComponent } from './Components/Content/Admin/admin-headerof-cdms/admin-headerof-cdms.component';
import { AllReportsGeneralComponent } from './Components/Content/Admin/all-reports-general/all-reports-general.component';
import { ReportGeneralCDMSComponent } from './Components/Content/Admin/report-general-cdms/report-general-cdms.component';
import { AllRecyclebinCDMSComponent } from './Components/Content/Admin/all-recyclebin-cdms/all-recyclebin-cdms.component';
import { RelationUserCdmsComponent } from './Components/Content/Admin/relation-user-cdms/relation-user-cdms.component';
import { AllRolesGenerCDMSComponent } from './Components/Content/Admin/all-roles-gener-cdms/all-roles-gener-cdms.component';

//-======================== REPORTS ADMINISTRATION CDMS ========================-\\
import { DashboardAdminComponent } from './Components/Content/Admin/report/dashboard-admin/dashboard-admin.component';
import { ContributionsCDMSComponent } from './Components/Content/Admin/report/contributions-cdms/contributions-cdms.component';
import { ContributionsAPComponent } from './Components/Content/Admin/report/contributions-ap/contributions-ap.component';
import { SystemVisitsACDMSComponent } from './Components/Content/Admin/report/system-visits-acdms/system-visits-acdms.component';

//-======================== GLOBAL COMPONENTS ========================-\\
import { HomeOfGeneralCDMSComponent } from './Components/Content/Global-Components/home-of-general-cdms/home-of-general-cdms.component';
import { SuportGeneralCDMSComponent } from './Components/Content/Global-Components/suport-general-cdms/suport-general-cdms.component';
import { AdvanceSearchCDMSComponent } from './Components/Content/Global-Components/advance-search-cdms/advance-search-cdms.component';
import { ManualGeneralCDMSComponent } from './Components/Content/Global-Components/manual-general-cdms/manual-general-cdms.component';
import { AllTaskAllLibraryComponent } from './Components/Content/Global-Components/all-task-all-library/all-task-all-library.component';
import { SAllTemplatesCDMSComponent } from './Components/Content/Global-Components/sall-templates-cdms/sall-templates-cdms.component';
import { QualityPoliciCDMSComponent } from './Components/Content/Global-Components/quality-polici-cdms/quality-polici-cdms.component';
import { RisksOpportunCDMSComponent } from './Components/Content/Global-Components/risks-opportun-cdms/risks-opportun-cdms.component';

//-======================== FORMS MODULE ========================-\\
import { FormTemplatesCDMSComponent } from './Components/Content/Global-Components/form-templates-cdms/form-templates-cdms.component';
import { FormBuilderCDMSComponent } from './Components/Content/Global-Components/form-builder-cdms/form-builder-cdms.component';
import { FormFillCDMSComponent } from './Components/Content/Global-Components/form-fill-cdms/form-fill-cdms.component';
import { FormPreviewCDMSComponent } from './Components/Content/Global-Components/form-preview-cdms/form-preview-cdms.component';
import { FormModalCDMSComponent } from './Components/Content/Global-Components/form-modal-cdms/form-modal-cdms.component';
import { FormReportsCDMSComponent } from './Components/Content/Global-Components/form-reports-cdms/form-reports-cdms.component';
import { FormGenAICDMSComponent } from './Components/Content/Global-Components/form-genai-cdms/form-genai-cdms.component';



//?==== FOR CHART ====?\\

//-======================== LIBRARY CCP ========================-\\
import { FileManagerLibCCPComponent } from './Components/Content/Libraries/Library-CCP/file-manager-lib-ccp/file-manager-lib-ccp.component';
import { VersionHistoryCCPComponent } from './Components/Content/Libraries/Library-CCP/version-history-ccp/version-history-ccp.component';
import { RecycleBinLibrCCPComponent } from './Components/Content/Libraries/Library-CCP/recycle-bin-libr-ccp/recycle-bin-libr-ccp.component';
import { FlowMonitoringCCPComponent } from './Components/Content/Libraries/Library-CCP/flow-monitoring-ccp/flow-monitoring-ccp.component';
import { LatestApprovedCCPComponent } from './Components/Content/Libraries/Library-CCP/latest-approved-ccp/latest-approved-ccp.component';
import { EditHeadersLibCCPComponent } from './Components/Content/Libraries/Library-CCP/edit-headers-lib-ccp/edit-headers-lib-ccp.component';
import { StructuredRepoCCPComponent } from './Components/Content/Libraries/Library-CCP/Reports/structured-repo-ccp/structured-repo-ccp.component';
import { ReportslistLibCCPComponent } from './Components/Content/Libraries/Library-CCP/Reports/reportslist-lib-ccp/reportslist-lib-ccp.component';
import { SeeAllTasksLibCCPComponent } from './Components/Content/Libraries/Library-CCP/Tasks/see-all-tasks-lib-ccp/see-all-tasks-lib-ccp.component';
import { CheckTaskAssigCCPComponent } from './Components/Content/Libraries/Library-CCP/Tasks/check-task-assig-ccp/check-task-assig-ccp.component';
import { SeeTemplatesInCCPComponent } from './Components/Content/Libraries/Library-CCP/Template/see-templates-in-ccp/see-templates-in-ccp.component';
import { DocumentExpireCCPComponent } from './Components/Content/Libraries/Library-CCP/document-expire-ccp/document-expire-ccp.component';

//?==== RECYCLEB CCP ====?\\
import { RecycleBinFileCCPComponent } from './Components/Content/Libraries/Library-CCP/RecycleBin/recycle-bin-file-ccp/recycle-bin-file-ccp.component';

//?==== FOR CRUD CCP ====?\\
import { TreeMoveProcesCCPComponent } from './Components/Content/Libraries/Library-CCP/Resource/tree-move-proces-ccp/tree-move-proces-ccp.component';

//?==== FOR ROLES CCP ====?\\
import { EditedRoleCDMSCCPComponent } from './Components/Content/Libraries/Library-CCP/Role/edited-role-cdmsccp/edited-role-cdmsccp.component';
import { CreateRoleCDMSCCPComponent } from './Components/Content/Libraries/Library-CCP/Role/create-role-cdmsccp/create-role-cdmsccp.component';
import { SeeAllGeneRoleCCPComponent } from './Components/Content/Libraries/Library-CCP/Role/see-all-gene-role-ccp/see-all-gene-role-ccp.component';
import { SeeUsersInRoleCCPComponent } from './Components/Content/Libraries/Library-CCP/Role/see-users-in-role-ccp/see-users-in-role-ccp.component';

//?==== FOR CHART ====?\\
import { ContributionsCCPComponent } from './Components/Content/Libraries/Library-CCP/Reports/contributions-ccp/contributions-ccp.component';





//?==== FOR CHART ====?\\

//-======================== LIBRARY FINANCES ========================-\\
import { FileManagerLibFINComponent } from './Components/Content/Libraries/Library-FIN/file-manager-lib-fin/file-manager-lib-fin.component';
import { VersionHistoryFINComponent } from './Components/Content/Libraries/Library-FIN/version-history-fin/version-history-fin.component';
import { FlowMonitoringFINComponent } from './Components/Content/Libraries/Library-FIN/flow-monitoring-fin/flow-monitoring-fin.component';
import { LatestApprovedFINComponent } from './Components/Content/Libraries/Library-FIN/latest-approved-fin/latest-approved-fin.component';
import { EditHeadersLibFINComponent } from './Components/Content/Libraries/Library-FIN/edit-headers-lib-fin/edit-headers-lib-fin.component';
import { EditHeadersMasterComponent } from './Components/Content/Libraries/Dynamic-Library/edit-headers-master/edit-headers-master.component';

import { ShareFolderLibFINComponent } from './Components/Content/Libraries/Library-FIN/share-folder-lib-fin/share-folder-lib-fin.component';
import { StructuredRepoFINComponent } from './Components/Content/Libraries/Library-FIN/Reports/structured-repo-fin/structured-repo-fin.component';
import { ReportslistLibFINComponent } from './Components/Content/Libraries/Library-FIN/Reports/reportslist-lib-fin/reportslist-lib-fin.component';
import { SeeAllTasksLibFINComponent } from './Components/Content/Libraries/Library-FIN/Tasks/see-all-tasks-lib-fin/see-all-tasks-lib-fin.component';
import { CheckTaskAssigFINComponent } from './Components/Content/Libraries/Library-FIN/Tasks/check-task-assig-fin/check-task-assig-fin.component';
import { VersionHAnnexeFINComponent } from './Components/Content/Libraries/Library-FIN/version-hannexe-fin/version-hannexe-fin.component';
import { HistoryAAnnexeFINComponent } from './Components/Content/Libraries/Library-FIN/history-aannexe-fin/history-aannexe-fin.component';
import { DocumentExpireFINComponent } from './Components/Content/Libraries/Library-FIN/document-expire-fin/document-expire-fin.component';

//?==== RECYCLEB FIN ====?\\
import { MenuRecyclebinFINComponent } from './Components/Content/Libraries/Library-FIN/RecycleBin/menu-recyclebin-fin/menu-recyclebin-fin.component';
import { RecycleBinFileFINComponent } from './Components/Content/Libraries/Library-FIN/RecycleBin/recycle-bin-file-fin/recycle-bin-file-fin.component';
import { RecycleBinAnneFINComponent } from './Components/Content/Libraries/Library-FIN/RecycleBin/recycle-bin-anne-fin/recycle-bin-anne-fin.component';

//?==== FOR CRUD FIN ====?\\
import { AddNewFProcessFINComponent } from './Components/Content/Libraries/Library-FIN/Resource/add-new-fprocess-fin/add-new-fprocess-fin.component';
import { UpdateFProcessFINComponent } from './Components/Content/Libraries/Library-FIN/Resource/update-fprocess-fin/update-fprocess-fin.component';
import { PropertiesProcFINComponent } from './Components/Content/Libraries/Library-FIN/Resource/properties-proc-fin/properties-proc-fin.component';
import { ContextMenuPRCFINComponent } from './Components/Content/Libraries/Library-FIN/Resource/context-menu-prcfin/context-menu-prcfin.component';
import { TreeMoveProcesFINComponent } from './Components/Content/Libraries/Library-FIN/Resource/tree-move-proces-fin/tree-move-proces-fin.component';
import { LibraryFinSharedModule } from './Components/Content/Libraries/Library-FIN/library-fin-shared.module';
import { PropertiesAnneFINComponent } from './Components/Content/Libraries/Library-FIN/Resource/properties-anne-fin/properties-anne-fin.component';

//?==== FOR ROLES FIN ====?\\
import { SeeAllGeneRoleFINComponent } from './Components/Content/Libraries/Library-FIN/Role/see-all-gene-role-fin/see-all-gene-role-fin.component';
import { CreateRoleCDMSFINComponent } from './Components/Content/Libraries/Library-FIN/Role/create-role-cdmsfin/create-role-cdmsfin.component';
import { EditedRoleCDMSFINComponent } from './Components/Content/Libraries/Library-FIN/Role/edited-role-cdmsfin/edited-role-cdmsfin.component';
import { SeeUsersInRoleFINComponent } from './Components/Content/Libraries/Library-FIN/Role/see-users-in-role-fin/see-users-in-role-fin.component';

//?==== FOR CHART ====?\\
import { ContributionsFINComponent } from './Components/Content/Libraries/Library-FIN/Reports/contributions-fin/contributions-fin.component';





//?==== FOR CHART ====?\\





//-======================== SHARED COMPONENTS ========================-\\
//?==== FOR CHARTS ====?\\
import { LargeChartBarCDMSComponent } from './shared/components/charts/large-chart-bar-cdms/large-chart-bar-cdms.component';
import { SimChartPieAngleComponent } from './shared/components/charts/sim-chart-pie-angle/sim-chart-pie-angle.component';
import { LargeChartArearcComponent } from './shared/components/charts/large-chart-arearc/large-chart-arearc.component';
import { SimpleChartArearComponent } from './shared/components/charts/simple-chart-arear/simple-chart-arear.component';
import { SimpleChartBarrcComponent } from './shared/components/charts/simple-chart-barrc/simple-chart-barrc.component';
import { SimpleChartPiercComponent } from './shared/components/charts/simple-chart-pierc/simple-chart-pierc.component';

//-======================== ERRORS ========================-\\
import { Unauthorized401Component } from './Components/Global/Errors/unauthorized401/unauthorized401.component';
import { CloseSessionComponent } from './Components/Global/Errors/close-session/close-session.component';
import { NotLibraryComponent } from './Components/Global/Errors/not-library/not-library.component';

import { NotPermissionComponent } from './Components/Temp/not-permission/not-permission.component';


//^======================== PIPES ========================^\\



//^======================== NGX-TRANSLATE ========================^\\
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutocompleteLibModule } from "angular-ng-autocomplete";
import { NgSelectComponent } from '@ng-select/ng-select';


//^======================== DIRECTIVES ========================^\\

//+====== CCP ======+\\
import { FormCcpDisabledDirective, ContainerFormCcpDisabledDirective } from "./Directives/Libraries/CCP/Forms/form-ccp-disabled.directive";


//+====== FIN ======+\\
import { FormFINDisabledDirective, ContainerFormFINDisabledDirective } from "./Directives/Libraries/FIN/form-fin-disabled.directive";


//+====== SEC ======+\\



//-==== Import PrimeNG modules ====-\\
import { MultiSelectModule } from 'primeng/multiselect';
import { PaginatorModule } from 'primeng/paginator';
import { DrawerModule } from 'primeng/drawer';
import { TableModule } from 'primeng/table';
import { TreeModule } from 'primeng/tree';
import { CardModule } from 'primeng/card';
import { TreeSelectModule } from 'primeng/treeselect';
import { TreeTableModule } from 'primeng/treetable';
import { DatePickerModule } from 'primeng/datepicker';
import { SelectModule } from 'primeng/select';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { InputNumberModule } from 'primeng/inputnumber';
import { TextareaModule } from 'primeng/textarea';
import { ChartModule } from 'primeng/chart';
import { JwtInterceptor } from './Services/Authentication/Token/jwt.interceptor';
import { FilterRolePipe } from './Pipes/Admin/filter-role.pipe';

@NgModule({ declarations: [
        AppComponent,
        //+============ GLOBAL ============+\\
        DashboardComponent,
        LoginCDMSComponent,
        SearchDocsApiComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        //+============ CONTENT ============+\\
        //-============ ADMINISTRATOR CDMS ============-\\
        AdministratorCDMSComponent,
        AdminGroupsOfCDMSComponent,
        RelationGroupCDMSComponent,
        AdminnUsersofCDMSComponent,
        AdminHeaderofCDMSComponent,
        AllReportsGeneralComponent,
        ReportGeneralCDMSComponent,
        AllRecyclebinCDMSComponent,
        RelationUserCdmsComponent,
        AllRolesGenerCDMSComponent,
        //-======= REPORTS ADMINISTRATION CDMS =======-\\
        DashboardAdminComponent,
        ContributionsCDMSComponent,
        ContributionsAPComponent,
        SystemVisitsACDMSComponent,
        //-============ GLOBAL COMPONENTS ============-\\
        HomeOfGeneralCDMSComponent,
        SuportGeneralCDMSComponent,
        AdvanceSearchCDMSComponent,
        ManualGeneralCDMSComponent,
        AllTaskAllLibraryComponent,
        SAllTemplatesCDMSComponent,
        QualityPoliciCDMSComponent,
        RisksOpportunCDMSComponent,
        //-============ FORMS MODULE ============-\\
        FormTemplatesCDMSComponent,
        FormBuilderCDMSComponent,
        FormFillCDMSComponent,
        FormPreviewCDMSComponent,
        FormModalCDMSComponent,
        FormReportsCDMSComponent,
        FormGenAICDMSComponent,
        //?==== FOR REPORT ====?\\
        //-============ LIBRARY CCP ============-\\
        FileManagerLibCCPComponent,
        VersionHistoryCCPComponent,
        RecycleBinLibrCCPComponent,
        FlowMonitoringCCPComponent,
        LatestApprovedCCPComponent,
        EditHeadersLibCCPComponent,
        StructuredRepoCCPComponent,
        ReportslistLibCCPComponent,
        SeeAllTasksLibCCPComponent,
        CheckTaskAssigCCPComponent,
        SeeTemplatesInCCPComponent,
        DocumentExpireCCPComponent,
        //?==== RECYCLEB CCP ====?\\
        RecycleBinFileCCPComponent,
        //?==== FOR CRUD CCP ====?\\
        TreeMoveProcesCCPComponent,
        //?==== FOR ROLES CCP ====?\\
        EditedRoleCDMSCCPComponent,
        CreateRoleCDMSCCPComponent,
        SeeAllGeneRoleCCPComponent,
        SeeUsersInRoleCCPComponent,
        //?==== FOR REPORT ====?\\
        ContributionsCCPComponent,
        //?==== FOR REPORT ====?\\
        //-============ LIBRARY FINANCES ============-\\
        FileManagerLibFINComponent,
        VersionHistoryFINComponent,
        FlowMonitoringFINComponent,
        LatestApprovedFINComponent,
        EditHeadersLibFINComponent,
        EditHeadersMasterComponent,

        ShareFolderLibFINComponent,
        StructuredRepoFINComponent,
        ReportslistLibFINComponent,
        SeeAllTasksLibFINComponent,
        CheckTaskAssigFINComponent,
        VersionHAnnexeFINComponent,
        HistoryAAnnexeFINComponent,
        DocumentExpireFINComponent,
        //?==== RECYCLEB FIN ====?\\
        MenuRecyclebinFINComponent,
        RecycleBinFileFINComponent,
        RecycleBinAnneFINComponent,
        //?==== FOR CRUD FIN ====?\\
        AddNewFProcessFINComponent,
        UpdateFProcessFINComponent,
        PropertiesProcFINComponent,
        ContextMenuPRCFINComponent,
        TreeMoveProcesFINComponent,
        PropertiesAnneFINComponent,
        //?==== FOR ROLE FIN ====?\\
        SeeAllGeneRoleFINComponent,
        CreateRoleCDMSFINComponent,
        EditedRoleCDMSFINComponent,
        SeeUsersInRoleFINComponent,
        //?==== FOR REPORT ====?\\
        ContributionsFINComponent,

        //-============ SHARED ============-\\
        //?==== FOR CHART ====?\\
        LargeChartArearcComponent,
        SimpleChartArearComponent,
        SimpleChartBarrcComponent,
        SimpleChartPiercComponent,
        SimChartPieAngleComponent,
        LargeChartBarCDMSComponent,
        //-============ ERRORS ============-\\
        Unauthorized401Component,
        CloseSessionComponent,
        NotLibraryComponent,
        //-============ TEMP ============-\\
        NotPermissionComponent,
        FilterRolePipe,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        FontAwesomeModule,
        FormsModule,
        ReactiveFormsModule,
        AutocompleteLibModule,
        NgSelectComponent,
        DragDropModule,
        BrowserAnimationsModule,
        //^======== DIRECTIVES ========^\\
        //+====== CCP ======+\\
        FormCcpDisabledDirective,
        ContainerFormCcpDisabledDirective,
        //+====== FIN ======+\\
        FormFINDisabledDirective,
        ContainerFormFINDisabledDirective,
        DocumentViewerComponent,

        //-==== Import PrimeNG modules ====-\\
        MultiSelectModule,
        PaginatorModule,
        DrawerModule,
        TableModule,
        TreeModule,
        CardModule,
        TreeSelectModule,
        TreeTableModule,
        DatePickerModule,
        SelectModule,
        ToggleSwitchModule,
        InputNumberModule,
        TextareaModule,
        ChartModule,
        LibraryFinSharedModule], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: JwtInterceptor,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi()),
        providePrimeNG({
            theme: {
                preset: Aura,
                options: {
                    darkModeSelector: 'none'
                }
            }
        })
    ] })
export class AppModule { }

